const estados = [
  { id: 1, nome: 'Acre' },
  { id: 2, nome: 'Alagoas' },
  { id: 3, nome: 'Amapá' },
  { id: 4, nome: 'Amazonas' },
  { id: 5, nome: 'Bahia' },
  { id: 6, nome: 'Ceará' },
  { id: 7, nome: 'Distrito Federal' },
  { id: 8, nome: 'Espírito Santo' },
  { id: 9, nome: 'Goiás' },
  { id: 10, nome: 'Maranhão' },
  { id: 11, nome: 'Mato Grosso' },
  { id: 12, nome: 'Mato Grosso do Sul' },
  { id: 13, nome: 'Minas Gerais' },
  { id: 14, nome: 'Pará' },
  { id: 15, nome: 'Paraíba' },
  { id: 16, nome: 'Paraná' },
  { id: 17, nome: 'Pernambuco' },
  { id: 18, nome: 'Piauí' },
  { id: 19, nome: 'Rio de Janeiro' },
  { id: 20, nome: 'Rio Grande do Norte' },
  { id: 21, nome: 'Rio Grande do Sul' },
  { id: 22, nome: 'Rondônia' },
  { id: 23, nome: 'Roraima' },
  { id: 24, nome: 'Santa Catarina' },
  { id: 25, nome: 'São Paulo' },
  { id: 26, nome: 'Sergipe' },
  { id: 27, nome: 'Tocantins' }
];

export const getEstados = () => {
  return estados;
};


// WEBPACK FOOTER //
// ./src/services/estadoService.js